import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { IBackgroundJobExtendedInfo } from './IBackgroundJobExtendedInfo';

export interface IGetBackgroundJobExtendedInfoParams {
  backgroundJobId: string;
}

export interface IGetBackgroundJobExtendedInfoResult extends IGetItemsResult, IBackgroundJobExtendedInfo {}

export class GetBackgroundJobExtendedInfoRequest extends Request<IGetBackgroundJobExtendedInfoParams, IGetBackgroundJobExtendedInfoResult> {
  constructor(params: IGetBackgroundJobExtendedInfoParams) {
    super('getBackgroundJobExtendedInfo', params);
  }
}
